module.exports = __webpack_public_path__ + "img/ipad_frame.04b69653.png";